import { Component, Input } from '@angular/core';
import { UserHomeConstants } from '../constants/user-home-constants';
import { UserHome } from '../models/user-home-document';
import { UserHomeTrainingIconNames } from '../models/user-home-icon-names';
import { LabelConstants } from '../../../shared/constants/label-constants';
import { UserHomeCardsAccess } from '../models/userHomeCardsAccess';
import { DashboardSummaryWithTrainingData } from '../models/user-home-dashboardSummary';

@Component({
  selector: 'app-user-home-training',
  templateUrl: './user-home-training.component.html',
  styleUrls: ['./user-home-training.component.scss']
})
export class UserHomeTrainingComponent {

  topBarTrainingTitle: string = UserHomeConstants.UserHomeTrainingTitle
  dataSets: any[]=[];
  userHomeTrainingData: UserHome = new UserHome();
  userDashboardData : any;
  userTrainingDashboardData: any;
  @Input() userHomeCardsAccess!: UserHomeCardsAccess;
  @Input() dashboardData!: DashboardSummaryWithTrainingData;

  constructor() {
  }

  ngOnInit() {
    if(this.dashboardData) {
      this.userTrainingDashboardData = this.dashboardData;
      this.dataSets = [];
      if (this.userHomeCardsAccess?.myPendingTrainingsAccess) {
        this.dataSets.push({
          name: LabelConstants.MyPendingTrainings,
          count: this.userTrainingDashboardData.myPendingTrainings
        });
      }

      if (this.userHomeCardsAccess?.myPendingTrainingPlanReviewsAccess) {
        this.dataSets.push({
          name: LabelConstants.MyTrainingPlanReviews,
          count: this.userTrainingDashboardData.myTrainingPlanReviews
        });
      }

      // Skill acknowledgements visible to all authenticated users
      this.dataSets.push({
        name: LabelConstants.MySkillAcknowledgements,
        count: this.userTrainingDashboardData.mySkillAcknowledgements
      });

      // Skill verifications: visible only when user has access (Skill Manager or Global Admin)
      if (this.userHomeCardsAccess?.mySkillVerificationsAccess) {
        this.dataSets.push({
          name: LabelConstants.MySkillVerifications,
          count: this.userTrainingDashboardData.mySkillVerifications
        });
      }

      const items = this.dataSets.map((item: any) => {
        const iconName = UserHomeTrainingIconNames[item.name.replace(/\s+/g, '') as keyof typeof UserHomeTrainingIconNames] || '';
        return { ...item, iconName };
      });
      this.userHomeTrainingData.trainingCards = items;
    }
   
  }

  

}
